<template>
        <dv5-shared-carousel
            :view="slideArr"
            :swipe=true
            :swipeToSlide=true
            :key="rowsToShow"
            :responsive="[
                {
                    'breakpoint': 100000,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1 //rowsToShow
                    }
                },
                {
                    'breakpoint': 1920,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1 //rowsToShow
                    }
                },
                {
                    'breakpoint': 1366,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1 //rowsToShow
                    }
                },
                {
                    'breakpoint': 1024,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1 //rowsToShow
                    }
                },
                {
                    'breakpoint': 768,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1
                    }
                },
            ]"
        >
            <div
                class="slide-wrapper"
                :slot="'slide'"
                slot-scope="props"
                :class="props.slideClass"
            >
                <dv5-multiline-slide-grid-h
                    :view="props.slide"
                    :rows="selectedBreakpoint.settings.rows"
                    :cols="selectedBreakpoint.settings.cols"

                >
                    <start-a-project2
                        v-for="(card, index) in props.slide"
                        :key="index"
                        :view="card"
                        :t="t"
                        :routes="view.handler_routes"
                        :is_free_plan="view.is_free_plan"
                    ></start-a-project2>
                </dv5-multiline-slide-grid-h>
            </div>
        </dv5-shared-carousel>
</template>


<script>
import MultilineSlideGridH from "../../../mixins/MultilineSlideGridH.js"
export default {
    name: "dv5-start-a-project",
    props: ["view"],
    mixins: [MultilineSlideGridH],
    display: "Transition",
    components: {
    },
    data() {
        return {
            toolsList: [],//dados das Cards
            dataCard: [],
            processing: false,
            t: { type: Object, },
            RouteAPI: null,
            StartAProject: [],
            rowsToShow: 3,
            responsive: [ // exemplo
                {
                    'breakpoint': 100000,
                    'settings': {
                        'cols': 5,
                        'rows': 3
                    }
                },
                {
                    'breakpoint': 1920,
                    'settings': {
                        'cols': 4,
                        'rows': 3
                    }
                },
                {
                    'breakpoint': 1600,
                    'settings': {
                        'cols': 3,
                        'rows': 3
                    }
                },
                {
                    'breakpoint': 1366,
                    'settings': {
                        'cols': 2,
                        'rows': 2
                    }
                },
                {
                    'breakpoint': 1024,
                    'settings': {
                        'cols': 1,
                        'rows': 1
                    }
                },
                {
                    'breakpoint': 768,
                    'settings': {
                        'cols': 1,
                        'rows': 1
                    }
                },
            ],
        };
    },

    mounted() {
        this.t = this.view.translation;
    },
    created() {
        this.concatRoute();
    },

    methods: {
        concatRoute(){
            this.RouteAPI = '/' + this.view['lang'] + '/office/start-a-project'
            this.initialize()
        },
        adjustScreen() {
            let value = null;
            if (window.screen.width > 1920) { value = 6 }
            else if (window.screen.width <= 1920) { value = 4 }

            if (this.StartAProject.length <= value) { this.rowsToShow = 1 }
            else if (this.StartAProject.length <= 12 && this.StartAProject.length > value) { this.rowsToShow = 2 }
            else { this.rowsToShow = 3 }
        },
        initialize() {
            var vm = this;
            vm.processing = true;

            axios
                .get(`${ vm.RouteAPI }`)
                .then(function(resposta) {
                    if (resposta.data.success) {
                        vm.StartAProject = resposta.data.data.start_a_project;
                        vm.adjustScreen();
                    } else {
                        alertMsg(
                            "error",
                            vm.t.get_cards_start_a_project_error + ' ' + vm.t.label_title_dv5_collapse_start_a_project
                        );
                    }
                })
                .catch(function(error) {
                    //console.log(error);
                })
                .finally(function() {
                    vm.processing = false;
                    vm.ready = true;
                });
        },
    },

    filters: {
    },

    computed: {
        cardList(){
            return this.StartAProject
        }
    },

    watch: {
    }
};
</script>
<style lang="scss">
.title_modal_remove > span{
    color: #FF4848;
    font-size: inherit;
}
</style>
<style scoped lang="scss">
    .slide-wrapper{
        background-color: rgba(#B8BBBF, 0.05)!important;
        padding: 10px 0!important;
        border-radius: 8px!important;
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/start-a-project/index.vue